
import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText } from '@wordpress/block-editor';
import './editor.scss';

export default function Edit(props) {
	const blockProps = useBlockProps({
		className: 'c4l-estimated-time'
	});
	const { attributes, setAttributes } = props;
	const { time, timeUnit } = attributes;

	return (
		<div {...blockProps}>
			<div className="c4l-estimated-time-container">
				<RichText
					tagName='div'
					className='c4l-estimated-time-time'
					value={time}
					onChange={(newVal) => setAttributes({ time: newVal })}
					placeholder={__('10', 'estimated-time')}
				/>
				<RichText
					tagName='div'
					className='c4l-estimated-time-time-unit'
					value={timeUnit}
					onChange={(newVal) => setAttributes({ timeUnit: newVal })}
					placeholder={__('min', 'estimated-time')}
				/>
			</div>
		</div>
	);
}
